import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const saveAsDraftAdminEventReducer = createReducer<State, Actions>(initialState, {
  [actions.saveAsDraftAdminEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.saveAsDraftAdminEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.saveAsDraftAdminEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.saveAsDraftAdminEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default saveAsDraftAdminEventReducer;
